import {useState, useEffect} from "react";
import HeaderPage from "../../../../palette/HeaderPage";
import {FormContainer, Layout} from "../../../../palette/Palette";
import VerticalSpace from "../../../../palette/VerticalSpace";
import Places from "./places/Places";
import {Slider} from "devextreme-react/slider";
import circle from '@turf/circle'
import Alerts from "../../../../palette/Alerts";
import {Button} from 'devextreme-react/button';
import {db} from "../../../../firebase/Firebase";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {LoadIndicator} from "devextreme-react/load-indicator";
import {useSnackbar} from "notistack";
import ZoneList from "./ZoneList";
import {Element} from 'react-scroll'
import {customScroll} from "../../../../utils/Scroll";
import MapComponent from "./RMap";
import {UpdateArray, Filters} from "../../../../utils/HelpFunctions";
import {useJsApiLoader} from '@react-google-maps/api'


const {REACT_APP_GM_KEY} = process.env

const initCoords = {
    latitude: 0,
    longitude: 0,
    zoom: 14,
};

function RestrictMap(props) {

    const {city, coordinates, companyName, idCompany} = props
    const {latitude, longitude} = coordinates

    const [place, setPlace] = useState(null);
    const [zoom, setZoom] = useState(16);
    const [viewport, setViewport] = useState(initCoords);
    const [sliderValue, setSliderValue] = useState({sliderValue: 0.5})
    const [radius, setRadius] = useState(0.5);
    const [polygon, setPolygon] = useState(null);
    const [point, setPoint] = useState(false);
    const [edit, setEdit] = useState(null)
    const [zones, setZones] = useState([])
    const [load, setLoad] = useState(false)
    const [idEdit, setIdEdit] = useState(null)
    const [add, setAdd] = useState(false)
    const [success, setSuccess] = useState(false)
    const [textSuccess, setTextSuccess] = useState('')

    const docRef = db.collection(companyName).doc(idCompany).collection('Restrict-Zones')
    const {enqueueSnackbar} = useSnackbar();

    const {isLoaded} = useJsApiLoader({
        googleMapsApiKey: REACT_APP_GM_KEY,
        libraries: ["places"]
    })

    useEffect(() => {
        const GetZones = async () => {
            await docRef.doc(city).get()
                .then((doc) => {
                    if (doc.exists) {
                        setZones(doc.data().zoneList)
                        setZoom(16)
                    } else {
                        setZones([])
                        setZoom(16)
                    }
                })
        }

        GetZones().catch(() => {
            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
        })
    }, [city])

    useEffect(() => {
        setViewport({...viewport, latitude: latitude, longitude: longitude});
    }, [coordinates, latitude, longitude,]);

    /*Place in map*/
    useEffect(() => {
        if (place) {
            const {latitude, longitude} = place
            setViewport({...viewport, latitude: latitude, longitude: longitude});
            setZoom(16)
        }
    }, [place])

    /*Change size zone slider*/
    useEffect(() => {
        if (viewport && !edit && polygon) {
            const center = [viewport.longitude, viewport.latitude];

            const options = {
                steps: 25,
                units: 'kilometers',
                options: {}
            };
            const polygon = circle(center, radius, options);
            const poly = polygon.geometry.coordinates

            const polyArray = []
            poly.forEach(items => {
                items.forEach(item => {
                    const obj = {lat: item[1], lng: item[0]}
                    polyArray.push(obj)
                })
            })

            setPolygon(polyArray)
        }

    }, [edit, idEdit, radius])

    /*Edit*/
    useEffect(() => {
        if (edit) {

            const zoneEdit = Filters(zones, 'ID', idEdit)
            const {latitude, longitude} = zoneEdit[0]
            setViewport({...viewport, latitude: latitude, longitude: longitude, zoom: 13})

            const center = [longitude, latitude];

            const options = {
                steps: 25,
                units: 'kilometers',
                options: {}
            };
            const polygon = circle(center, radius, options);
            const poly = polygon.geometry.coordinates

            const updateRadius = UpdateArray(zones, 'ID', idEdit, 'radius', radius)
            setZones(updateRadius)
            const polyArray = []
            poly.forEach(items => {
                items.forEach(item => {
                    const obj = {lat: item[1], lng: item[0]}
                    polyArray.push(obj)
                })
            })

            setPolygon(polyArray)
        }
    }, [edit, idEdit, radius])

    const getPointer = (lat, lng) => {
        setAdd(false)
        setSliderValue({sliderValue: 0.5})
        const center = [lng, lat];
        const options = {
            steps: 25,
            units: 'kilometers',
            options: {}
        };
        const polygon = circle(center, radius, options);
        const poly = polygon.geometry.coordinates

        const polyArray = []
        poly.forEach(items => {
            items.forEach(item => {
                const obj = {lat: item[1], lng: item[0]}
                polyArray.push(obj)
            })
        })

        setPolygon(polyArray)
        setViewport({...viewport, latitude: lat, longitude: lng})
        setPoint(true)
        setZoom(15)
    }

    const onValueChangedSlider = ({value}) => {
        setSliderValue({sliderValue: value})
        setRadius(value)
    }

    const onEditZone = async () => {
        const zoneList = [...zones];
        setLoad(true)
        customScroll('list-element', 500)
        await docRef.doc(city).set({zoneList})
            .then(() => {
                setSuccess(true)
                setTextSuccess('Zona actualizada!')
                setTimeout(() => {
                    setLoad(false)
                    setEdit(false)
                    setPoint(false)
                    setSuccess(false)
                    setTextSuccess('')
                }, 2300)
            }).catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                setTextSuccess('')
                setSuccess(false)
                setSuccess(true)
                setLoad(false)
                setEdit(false)
                setPoint(false)
            })
    }

    const addZoneList = async () => {
        const zoneList = [...zones];
        const newObject = {...viewport, ID: zoneList.length + 1, zone: `Zona ${zoneList.length + 1}`, radius: radius}
        zoneList.push(newObject)
        setLoad(true)
        setAdd(true)
        customScroll('list-element', 500)
        setZoom(14)
        if (point) {
            setZones(zoneList)
            setLoad(true)
            await docRef.doc(city).set({zoneList})
                .then(() => {
                    setSuccess(true)
                    setTextSuccess('Zona agregada exitosamente')
                    setTimeout(() => {
                        setTextSuccess('')
                        setSuccess(false)
                        setLoad(false)
                        setPoint(false)
                    }, 2000)
                }).catch(() => {
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                    setTextSuccess('')
                    setAdd(false)
                    setLoad(false)
                    setPoint(false)
                })
        } else {
            NotiStackInfo('Señale un punto en el mapa!', 'warning', enqueueSnackbar)
        }
    }

    return (
        <div>
            <div className="zones-container">
                <HeaderPage icon={'fas fa-store-alt-slash'} text={`Restricción para la ciudad de ${city}`}
                            load={true}/>
                <VerticalSpace space={34}/>
                {isLoaded && <Places setPlace={setPlace} place={place}/>}
                <FormContainer>
                    {isLoaded &&
                    <MapComponent
                        center={{lat: viewport.latitude, lng: viewport.longitude}}
                        zoom={zoom}
                        places={zones}
                        add={add}
                        polygon={polygon}
                        radius={radius}
                        onClick={getPointer}
                    />}
                    <VerticalSpace space={15}/>
                    {success && <Alerts severity={'success'} body={textSuccess}/>}
                    <Layout color={'transparent'} row center space>
                        <Slider min={0}
                                max={10}
                                tooltip={{
                                    enabled: true,
                                    showMode: 'always',
                                    position: 'bottom',
                                    format
                                }}
                                width={'100%'}
                                step={0.01}
                                value={sliderValue.sliderValue}
                                onValueChanged={onValueChangedSlider}/>
                    </Layout>
                </FormContainer>
                {(point || zones.length) > 0 ?
                    <Layout color={'transparent'}>
                        {edit ?
                            <Layout color={'transparent'} row center positionR>
                                <Button
                                    type={'success'}
                                    width={170}
                                    disabled={load}
                                    onClick={onEditZone}>
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        {!load && <i className="far fa-save" style={{marginRight: 7}}/>}
                                        <LoadIndicator id="small-indicator" height={20} width={20} visible={load}/>
                                        <span className="dx-button-text">Guardar cambios</span>
                                    </div>

                                </Button>
                            </Layout> :
                            <Layout color={'transparent'} row center positionR>
                                <Button
                                    type={'success'}
                                    width={170}
                                    disabled={load}
                                    onClick={addZoneList}>
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        {!load && <i className="far fa-check-circle"/>}
                                        <LoadIndicator id="small-indicator" height={20} width={20} visible={load}/>
                                        <span className="dx-button-text" style={{marginLeft: 5}}>Agregar zona.</span>
                                    </div>
                                </Button>
                            </Layout>}
                    </Layout> :
                    <Layout color={'transparent'}>
                        <div style={{height: 30}}/>
                        <Alerts severity="warning" body={'Señale un punto en el mapa!'}/>
                    </Layout>
                }
            </div>

            <VerticalSpace space={20}/>
            <Element name="list-element" className="element"/>
            <ZoneList setZones={setZones} radius={radius} data={zones} docRef={docRef} city={city}
                      setIdEdit={setIdEdit} setEdit={setEdit} setSliderValue={setSliderValue}
                      setRadius={setRadius}/>
        </div>
    )
}

export default RestrictMap

function format(value) {
    return `${value}km`;
}
